import React from 'react';

export const DialerCall = ({ width = 16, height = 16, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.04507 3.52944C3.88543 3.52944 3.73232 3.59286 3.61944 3.70574C3.51019 3.81499 3.44728 3.9619 3.44333 4.11595C3.58177 6.30937 4.51554 8.37728 6.06995 9.93169C7.62437 11.4861 9.69228 12.4199 11.8857 12.5583C12.0398 12.5544 12.1867 12.4915 12.2959 12.3822C12.4088 12.2693 12.4722 12.1162 12.4722 11.9566V9.95635L10.3169 9.09422L9.6777 10.1595C9.51653 10.4281 9.17626 10.5282 8.8953 10.3896C7.46934 9.68639 6.31526 8.5323 5.612 7.10635C5.47344 6.82539 5.57354 6.48512 5.84216 6.32394L6.90743 5.68478L6.04529 3.52944H4.04507ZM2.76817 2.85447C3.10683 2.51582 3.56614 2.32556 4.04507 2.32556H6.45282C6.69896 2.32556 6.9203 2.47542 7.01171 2.70395L8.21559 5.71364C8.32531 5.98795 8.21974 6.30135 7.9664 6.45335L6.95875 7.05794C7.45467 7.86671 8.13493 8.54698 8.94371 9.04289L9.5483 8.03525C9.7003 7.78191 10.0137 7.67633 10.288 7.78606L13.2977 8.98994C13.5262 9.08135 13.6761 9.30269 13.6761 9.54882V11.9566C13.6761 12.4355 13.4858 12.8948 13.1472 13.2335C12.8085 13.5721 12.3492 13.7624 11.8703 13.7624C11.8581 13.7624 11.8459 13.762 11.8338 13.7613C9.339 13.6097 6.986 12.5503 5.21868 10.783C3.45137 9.01565 2.39197 6.66264 2.24037 4.16789C2.23963 4.15573 2.23926 4.14356 2.23926 4.13138C2.23926 3.65245 2.42951 3.19313 2.76817 2.85447Z"
    />
  </svg>
);
